import { render, staticRenderFns } from "./SelectMemo.vue?vue&type=template&id=d48236e8&"
import script from "./SelectMemo.vue?vue&type=script&lang=js&"
export * from "./SelectMemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports